module.exports = __webpack_public_path__ + "resources/img/stop@3x.2b102b1c.png";